"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var reduxCache_1 = require("./reduxCache");
exports.ReduxCache = reduxCache_1.ReduxCache;
__export(require("./reducer"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-cache-redux/lib/index.js
// module id = 163
// module chunks = 104158497352714 114276838955818 230539012308250